<template>
  <div class="sended">
    <figure class="sended__check-icon">
      <object :data="successOutline" type="image/svg+xml"></object>
      <sm-alert
        type='success'
        :removed='has3secondsPassed'
        title="¡Recibimos el mensaje que has definido!"
        message="Estamos en proceso de verificación de estos prospectos. Muy pronto nos comunicaremos contigo para confirmarte el número exacto de prospectos al que se enviará el mensaje"
      />
    </figure>
    <p class="sended__text">¡Recibimos el mensaje que has definido!</p>
    <p class="sended__text">Revisaremos tu selección y te enviaremos un correo a <span class="sended__text__email">{{ me.email }}</span> cuando tu mensaje sea aprobado, junto con el número de usuarios una vez sean verificados.</p>
    <p class="sended__text sended__text--paddingX-plus">Podrás hacer seguimiento a los prospectos que han manifestado interes en "estado de solicitudes". Recuerda actualizarlo para que ellos sepan en que estado se encuentra su solicitud de crédito.</p>
  </div>
</template>

<script>
import successOutline from '@/assets/success-outline.svg'

export default {
  name: 'Sended',
  data () {
    return {
      successOutline,
      has3secondsPassed: false
    }
  },
  computed: {
    me () {
      return this.$store.getters.me
    }
  },
  created () {
    setTimeout(() => {
      this.has3secondsPassed = true
    }, 5000)
  }
}
</script>

<style>
.sended__top__arrow {
  color: #00b19d;
  font-size: large;
  font-weight: bold;
  line-height: 2;
  text-align: center;

  background-color: #ffffff;
  border-radius: 50%;
  box-shadow: 1px 2px 5px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  height: fit-content;
  width: 37px;
}

.sended__check-icon {
  position: relative;
  top: 0;
}

.sended__top__arrow__green-icon {
  color: #00b19d;
}

.sended__top__arrow__green-icon:hover {
  opacity: 0.7;
}

.sended__text {
  color: #595959;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  text-align: center;

  margin-bottom: 20px;
  padding: 0 50px;
}

.sended__text__email {
  color: #00535e;
  font-style: italic;
}

.sended__text--paddingY-plus {
  padding: 0 70px;
}
</style>
